"use client"
import { useMe } from "@/api/user"

export enum FeatureFlag {
  adminHeader = "adminHeader",
  attachDocs = "attachDocs",
  attachEvents = "attachEvents",
  attachFiles = "attachFiles",
  attachIssue = "attachIssue",
  projectSystemPrompt = "projectSystemPrompt",
  chatHistory = "chatHistory",
  chatModelSelect = "chatModelSelect",
  chatShowGenie2Model = "chatShowGenie2Model",
  codeExecution = "codeExecution",
  cosineNEXT = "cosine_NEXT",
  dbMigration = "dbMigration",
  developerAPI = "developerAPI",
  editor = "GENIE_EDITOR",
  legacyAutomations = "legacyAutomations",
  loginWithAzure = "loginWithAzure",
  loginWithPassword = "loginWithPassword",
  onboarding = "onboarding",
  prChecksAndPreviews = "prChecksAndPreviews",
  prettyErrLogsInChat = "prettyErrLogsInChat",
  projectsTemplates = "projectsTemplates",
  promptOptions = "promptOptions",
  showContextWindowDebug = "showContextWindowDebug",
  showOutput = "showOutput",
  showVercel = "showVercel",
  studioUX = "studioUX",
  taskDifficulty = "taskDifficulty",
  taskEdit = "taskEdit",
  taskPause = "taskPause",
  taskRetry = "taskRetry",
  taskStop = "taskStop",
  timelineEdit = "contextEdit",
  uploadImage = "taskUploadImage",
  chatV2 = "CHAT_V2",
  slackIntegration = "slackIntegration",
  benscape = "BENSCAPE",
  vercelPreview = "VERCEL_PREVIEW",
  quickThink = "QUICK-THINK",
  autopm = "AUTO_PM",
  homepage = "HOMEPAGE",
  importProjectFromUrl = "IMPORT_PROJECT_FROM_URL",
  ccode_cli = "CCODE_CLI",
  autopmUseo3Plus = "AUTOPM_USE_O3_PLUS",
  deployments = "DEPLOYMENTS",
}

export const useFeatureFlag = (flag: FeatureFlag) => {
  const { data: user } = useMe()
  if (!user) {
    return false
  }
  const flagResult = user.flags?.[flag.toString()]
  if (!flagResult) {
    return false
  }
  return flagResult.enabled
}

type FlaggedProps = {
  flag: FeatureFlag
  children: React.ReactNode
}

export const FlaggedDisabled = ({ flag, children }: FlaggedProps) =>
  useFeatureFlag(flag) ? null : children

export const Flagged = ({ flag, children }: FlaggedProps) => {
  return useFeatureFlag(flag) ? children : null
}
